import styles from "./leaderboard.module.css";

const leaderboardStyles = {
  leaderboard: `bg-themeShadowColor w-full flex flex-col rounded-[11px] overflow-hidden border border-liveGamePrimaryColor min-h-[288px] ${styles.leaderboard}`, 
  gameLeaderboardSection: `flex flex-col gap-[10px]`,
  sectionTitle: `text-[16px] py-[3px] font-[400] text-left capitalize bg-liveGamePrimaryColor pl-4 ${styles.sectionTitle}`,
  no_leaderboard: `max-w-[204px] h-auto w-full ${styles.no_leaderboard}`,
  no_leaderboard_text: `text-[16px] ${styles.no_leaderboard_text}`,
  leaderboardContainer: `overflow-x-auto px-[10px] pb-[10px] h-full
                          screen-500:h-[unset]
  `,
  headers: `screen-500:min-w-[450px]
            sm:overflow-x-visible
  `,
  headerRow: `flex justify-between font-[15px] font-[500]`, 
  headerText: `flex-1 text-center`,
  
  dataRow: `relative flex justify-between items-center py-[5px] mt-2 rounded-[10px] min-h-[36px]
            screen-500:min-w-[450px]
            md:min-w-[350px]
  `,
  rank: `flex-1 flex justify-center items-center font-[500] text-[14px]
         screen-500:text-[16px]
  `, 
  trophyIcon: `w-[15px] h-[15px]
               screen-500:w-[20px] screen-500:h-[20px]
  `,  
  playerImageContainer: `flex-1 flex justify-start
                         screen-500:justify-center
  `,
  // figureContainer: `w-[30px] h-[30px] rounded-full overflow-hidden border-[1px] border-liveGamePrimaryColor`,
  playerImage: `object-cover bg-transparent w-[20px] h-[20px] rounded-full overflow-hidden border-[1px] border-liveGamePrimaryColor
                screen-500:w-[30px] screen-500:h-[30px] 
  `,
  username: `flex-1 font-[400] text-[12px] text-ellipsis whitespace-nowrap overflow-hidden
             screen-500:text-[15px]
  `,
  points: `flex-1 text-center font-[400] text-[12px]
           screen-500:text-[15px]
  `,
  dataContainer: `overflow-y-auto overflow-x-hidden h-full
                  screen-500:max-h-[350px]
  `, 
  
  lowestRankRow: `bg-[#B98B00]`,
  rankDiv: `absolute left-[-3px] -translate-y-1/2 top-1/2 w-[6px] h-[20px] rounded-[5px]
            screen-500:h-[24px]
  `, 
  goldRank: `bg-yellow-500`, 
  silverRank: `bg-gray-400`,  
  bronzeRank: `bg-[#A6644F]`,
  moveUp: `transform translate-y-[-10px]`,
  moveDown: `transform translate-y-[10px]`,
  rowHeight: `h-[60px]`,
};

export { leaderboardStyles };
